import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { defaultAvatar, DelIcon, EditIcon, PlusIcon, ProjectNameIcon, StatusCheckIcon, UserIcon, UserRoleIcon, EyeIcon } from 'assets';
import { useSelector } from 'react-redux';
import GenericTable from 'shared/components/common/table/table';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import Switch2 from 'shared/components/common/switch2/Switch2';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { DeleteUserMutation, GetAllUserQuery, RegisterMutation, UpdateUserMutation } from 'shared/services/auth_service/AuthService';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import UserRole from 'shared/modal/user_role/UserRole';
import moment from 'moment';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import ModalImage from 'shared/components/common/custom_image_lightbox/ModalImage';
import SearchBar from 'shared/components/common/searchbar/SearchBar';
import ExcelExport from 'shared/components/common/ExcelExport/ExcelExport';
import { toastMessage } from 'shared/components/toast/Toast';
import DeleteConfirmation from 'shared/modal/delete_confirmation/DeleteConfirmation';
import UserAddModal from 'shared/modal/user_add/UserAddModal';
import UserEditModal from 'shared/modal/user_edit/UserEditModal';


export default function ManageUser() {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const [userList, setUserList] = useState([]);
    const [modalShow, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectEditUser, setSelectEditUser] = useState(null);
    const [showRole, setShowRole] = useState(false);
    const [selectRole, setSelectRole] = useState(null);
    const { mutate, isLoading, isError, isSuccess, error, data } = RegisterMutation();
    const { mutate: updateMutate, isLoading: updateLoading, isSuccess: updateSuccess } = UpdateUserMutation();
    const { mutate: delMutate, isLoading: delLoading, isSuccess: delSuccess } = DeleteUserMutation();
    const [searchMenu, setsearchMenu] = useState('');
    const [clicksearch, setClickSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectDelUser, setSelectDelUser] = useState(null);
    const [openDelConfirm, setOpenDelConfirm] = useState(false);
    const [userImgSend, setuserimgsend] = useState('');


    const obj = {};
    if (clicksearch) {
        obj['search'] = clicksearch;
    }
    const allTaskQueryParams = new URLSearchParams(obj).toString();
    const { isLoading: isLoad, data: dataUser, isError: isErr, error: err, refetch } = GetAllUserQuery(allTaskQueryParams);
    const closeDelConfirmation = () => setOpenDelConfirm(false);
 

    const submitUser = (values) => {
        mutate(values);
    };

    const submitEditUser = ({ id, data }) => {
        updateMutate({ id, data });
    };

    useEffect(() => {
        if (delSuccess || updateSuccess) {
            setSelectDelUser(null);
            closeDelConfirmation();
            refetch(); // Refetch user list from API
        }
        if (dataUser) {
            setSearchResults(dataUser);
        }
    }, [searchMenu, dataUser, delSuccess, updateSuccess, refetch]);




    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Profile
                    </div>
                ),
                accessor: 'profile',
                Cell: ({ row }) => (
                    <div>
                        {row?.original?.profile_image ? (
                            <ModalImage small={row?.original?.profile_image} large={row?.original?.profile_image} alt="Wise Tech" className={classNames(styles.profileImages)} />
                        ) : (
                            <img src={defaultAvatar} className={classNames(styles.Img, 'me-1')} width={50} />
                        )}
                    </div>
                )
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Name
                    </div>
                ),
                accessor: 'project',
                Cell: ({ row }) => (
                    <div className={classNames(styles.UserColumn)}>
                        {/* <img src={row.original.profile_image ?? defaultAvatar} className={classNames(styles.Img,'me-1')} width={20}  /> */}
                        {row.original.name}
                    </div>
                )
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Role
                    </div>
                ),
                accessor: 'authorize',
                Cell: ({ row }) => <div>{row.original.authorize}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Email
                    </div>
                ),
                accessor: 'email',
                Cell: ({ row }) => <div>{row.original.email}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Date Created
                    </div>
                ),
                accessor: 'Date Created',
                Cell: ({ row }) => <div>{moment(row.original?.created_at).format('DD, MMM YYYY')}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Date Updated
                    </div>
                ),
                accessor: 'Date Updated',
                Cell: ({ row }) => <div>{moment(row.original?.updated_at).format('DD, MMM YYYY')}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        View Password
                    </div>
                ),
                accessor: 'View Password',
                Cell: ({ row }) => <EyeIcon cursor="pointer" onClick={() => toastMessage('info', `Your Password=${row.original.visiblePass}`)} />
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Action
                    </div>
                ),
                accessor: 'status',
                Cell: ({ row }) => (
                    <div className={classNames(styles.Statuses, 'd-flex align-items-center gap-2')}>
                        <DelIcon
                            className="pointer"
                            title="Delete User"
                            onClick={() => {
                                if (isRestrictActions(screenEnum.user, screenActionEnum.delete)) {
                                    setOpenDelConfirm(true);
                                    setSelectDelUser(row.original);
                                }
                            }}
                        />
                        <EditIcon
                            className={classNames(styles.OptionIcon, 'pointer')}
                            title="Edit User"
                            onClick={() => {
                                if (isRestrictActions(screenEnum.user, screenActionEnum.update)) {
                                    setSelectEditUser(row.original);
                                    setShowEditModal(true);
                                }
                            }}
                        />
                        <UserRoleIcon
                            className={classNames(styles.OptionIcon, 'pointer')}
                            title="Access Permissions"
                            onClick={() => {
                                if (isRestrictActions(screenEnum.user, screenActionEnum.update)) {
                                    setSelectRole(row.original.role);
                                    setShowRole(!showRole);
                                    setuserimgsend(row?.original?.profile_image ? row?.original?.profile_image : '');
                                }
                            }}
                        />
                    </div>
                )
            }
        ],
        []
    );
    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <SearchBar
                    searchKey="name"
                    suggestionsSource={dataUser}
                    onSearchChange={setSearchResults}
                />
                <div className={styles.Header}>
                    <Heading heading={'Users'} headingStyle={styles.Heading} />
                    <div className="d-flex">
                        <CustomButton
                            Icon={PlusIcon}
                            text={'Add User'}
                            containerStyle={styles.SubmitBtn}
                            submitHandle={() => {
                                if (isRestrictActions(screenEnum.user, screenActionEnum.create)) {
                                    setShowModal(!modalShow);
                                }
                            }}
                        />
                        <ExcelExport data={dataUser} fileName={'User List'} />
                    </div>
                </div>
                <GenericTable columns={columns} data={searchResults || []} TableWrapperStyle={classNames(styles.Table)} />
            </div>
            <UserAddModal show={modalShow} handleClose={() => setShowModal(!modalShow)} submitUser={submitUser} userList={userList} setUserList={setUserList} />
            <UserEditModal show={showEditModal} handleClose={() => { setShowEditModal(false); setSelectEditUser(null); }} submitEditUser={submitEditUser} editUser={selectEditUser} isLoading={updateLoading} />
            <UserRole show={showRole} RoleItem={selectRole} userProfileImg={userImgSend} handleClose={() => setShowRole(!showRole)} />
            <DeleteConfirmation
                show={openDelConfirm}
                loading={delLoading}
                ConfimationHeading="Delete User"
                Desc={'Are you sure you want to delete the user?'}
                DeleteHandler={() => {
                    delMutate(selectDelUser?._id);
                }}
                handleClose={closeDelConfirmation}
            />
            {(isLoading || updateLoading) && <OverlayLoading />}
        </DashboardWrapper>
    );
}
